/** AUTO-GENERATED — minimum 100 lines per pool. Run: node scripts/generate-tab-roast-pools.mjs */

export const CHEAP_LINES: readonly string[] = [
  "Eighteen percent is the floor, not a suggestion. The server noticed.",
  "That tip is a participation trophy for showing up.",
  "You did the math and still chose violence.",
  "The kitchen staff are naming a special after your generosity. It is water.",
  "If the bill was that painful, maybe stay in and eat cereal.",
  "You left a tip that says \"I understand the concept, I just reject it.\"",
  "Servers remember faces. Yours just got filed under \"never again.\"",
  "That is not a tip. That is spare change with extra steps.",
  "You stiffed a human being who brought you food on purpose.",
  "The bartender is not \"part of the vibe.\" The bartender is why you have a drink.",
  "You tipped like the service fee was a personal insult. That is 10% speaking, not math.",
  "The server ran your card and your conscience in parallel. Only one cleared.",
  "That gratuity is what people leave when they want credit for ordering water with extra ice.",
  "You treated tipping like a optional side quest. The main quest was not being cheap.",
  "If shame had a tip jar, you would still underfill it.",
  "You left enough for a thank-you nod, not a thank-you living wage.",
  "The bill was not a negotiation. Your tip suggests you thought it was.",
  "You tipped like you personally washed the dishes. You did not.",
  "That percentage is what you use when you want the industry to forget your face. It will not.",
  "Cheap tips do not make you mysterious. They make you memorable for the wrong reason.",
  "You did not stiff them on accident. The calculator was right there.",
  "Your tip says you enjoyed the meal but resented the existence of workers.",
  "Somewhere a manager is explaining your tab to a new hire as a cautionary tale.",
  "You tipped like tax season was tomorrow and joy was taxable.",
  "The server smiled anyway. That is professionalism, not forgiveness.",
  "You left a tip that would not cover the gas they spent being nice to you.",
  "If generosity were a menu item, you would send it back.",
  "You tipped like the bartender was an ATM that poured poorly.",
  "That is not frugal. That is a personality trait with a receipt.",
  "You saved 2 dollars and spent twice that in reputation.",
  "You tipped like the service fee was a personal insult. That is 11% speaking, not math.",
  "You saved 3 dollars and spent twice that in reputation.",
  "You tipped like the service fee was a personal insult. That is 12% speaking, not math.",
  "You saved 4 dollars and spent twice that in reputation.",
  "You tipped like the service fee was a personal insult. That is 13% speaking, not math.",
  "You saved 5 dollars and spent twice that in reputation.",
  "You tipped like the service fee was a personal insult. That is 14% speaking, not math.",
  "You saved 6 dollars and spent twice that in reputation.",
  "You tipped like the service fee was a personal insult. That is 15% speaking, not math.",
  "You tipped like the service fee was a personal insult. That is 16% speaking, not math.",
  "You tipped like you were paying a toll you did not owe then left a review about \"atmosphere.\"",
  "That gratuity with energy that screams \"I read the bill wrong on purpose\" which is why we built this app.",
  "The server saw your total and like the pour was personal but the tip was not and thought nobody would notice.",
  "Your bill was fine but your tip as though kindness were taxed and you filed an extension then asked if water refills are free.",
  "The bartender ran the card and like you thought autograt was a suggestion and moved on without learning.",
  "On this tab you with a percentage that belongs on a warning label then asked for the Wi-Fi password.",
  "Tonight you left like the food was good but humanity was extra like that was the whole personality.",
  "The math said twenty percent but you as if rounding down were a sport so the staff will remember you anyway.",
  "Your receipt tells a story where you like you tipped with vibes instead of dollars and called it budgeting.",
  "The industry notes that you with the audacity of a person who snaps at the register then wondered why the refills stopped.",
  "History will remember that you like the service was optional which is a choice you will defend online.",
  "The tip line says you like generosity was a limited-time offer you missed and still ordered dessert.",
  "Your wallet whispered but you like the night was great until the tip then tipped on the post-tax total incorrectly.",
  "Common decency arrived and you with the confidence of someone who never worked a shift like shame was not on the menu.",
  "The calculator cried when you as if the server was part of the furniture and blamed the economy.",
  "You left 10% at a bar and logged it in your head.",
  "You left 11% at a pub and justified it in your head.",
  "You left 12% at a restaurant and rationalized it in your head.",
  "You left 13% at a dive and celebrated it in your head.",
  "You left 14% at a spot and defended it in your head.",
  "You left 15% at a joint and repeated it in your head.",
  "You left 16% at a room and doubled down on it in your head.",
  "You left 17% at a counter and logged it in your head.",
  "You left 10% at a booth and justified it in your head.",
  "You left 11% at a patio and rationalized it in your head.",
  "So You left 12% at a bar and celebrated it in your head.",
  "So You left 13% at a pub and defended it in your head.",
  "So You left 14% at a restaurant and repeated it in your head.",
  "So You left 15% at a dive and doubled down on it in your head.",
  "So You left 16% at a spot and logged it in your head.",
  "So You left 17% at a joint and justified it in your head.",
  "So You left 10% at a room and rationalized it in your head.",
  "So You left 11% at a counter and celebrated it in your head.",
  "So You left 12% at a booth and defended it in your head.",
  "So You left 13% at a patio and repeated it in your head.",
  "Apparently You left 14% at a bar and doubled down on it in your head.",
  "Apparently You left 15% at a pub and logged it in your head.",
  "Apparently You left 16% at a restaurant and justified it in your head.",
  "Apparently You left 17% at a dive and rationalized it in your head.",
  "Apparently You left 10% at a spot and celebrated it in your head.",
  "Apparently You left 11% at a joint and defended it in your head.",
  "Apparently You left 12% at a room and repeated it in your head.",
  "Apparently You left 13% at a counter and doubled down on it in your head.",
  "Apparently You left 14% at a booth and logged it in your head.",
  "Apparently You left 15% at a patio and justified it in your head.",
  "Classic move: You left 16% at a bar and rationalized it in your head.",
  "Classic move: You left 17% at a pub and celebrated it in your head.",
  "Classic move: You left 10% at a restaurant and defended it in your head.",
  "Classic move: You left 11% at a dive and repeated it in your head.",
  "Classic move: You left 12% at a spot and doubled down on it in your head.",
  "Classic move: You left 13% at a joint and logged it in your head.",
  "Classic move: You left 14% at a room and justified it in your head.",
  "Classic move: You left 15% at a counter and rationalized it in your head.",
  "Classic move: You left 16% at a booth and celebrated it in your head.",
  "Classic move: You left 17% at a patio and defended it in your head.",
  "Statistically, You left 10% at a bar and repeated it in your head.",
  "Statistically, You left 11% at a pub and doubled down on it in your head.",
  "Statistically, You left 12% at a restaurant and logged it in your head.",
  "Statistically, You left 13% at a dive and justified it in your head.",
  "Statistically, You left 14% at a spot and rationalized it in your head.",
]

export const STANDARD_LINES: readonly string[] = [
  "A normal tip. Wild. You can still be roasted for other reasons.",
  "Twenty percent. You did the assignment. Gold star, then get out.",
  "Respectable. Boring. The server will survive you.",
  "You tipped like an adult. Do not let it go to your head.",
  "Solid. Nobody is writing a Yelp novel about you either way.",
  "That is the amount that says you have eaten in public before.",
  "Serviceable tip. Now try being this consistent on a Tuesday.",
  "You hit the default. The app is almost disappointed.",
  "Twenty percent. The statistical median of decency. You are statistically fine.",
  "You tipped like you read one article about etiquette in 2018 and stopped there.",
  "Not heroic, not criminal. The lukewarm oatmeal of gratuity.",
  "You met society halfway. Society shrugged.",
  "That tip will not get you comped. It will not get you banned. Carry on.",
  "You tipped like someone who knows better and occasionally acts like it.",
  "Standard issue generosity. The server will not frame the receipt.",
  "You did the normal thing. Congratulations on baseline humanity.",
  "Respectable math for a respectable night that will not make any stories.",
  "You tipped like the bill was real and your budget was real. Rare combo.",
  "Neither saint nor goblin. Just a person with a calculator.",
  "That percentage is the beige paint of tipping culture.",
  "You left enough to avoid side-eye and not enough for a nickname.",
  "Fine. Fine is doing a lot of work in that sentence.",
  "You tipped like you have been here before and might come back. Reasonable.",
  "The industry runs on people like you being mostly okay most nights.",
  "You did not flex. You did not flee. You tipped.",
  "A perfectly adequate thank-you in numeric form.",
  "You hit the middle lane and stayed there. Very on-brand for you.",
  "Nothing to brag about, nothing to apologize for. Yet.",
  "You tipped like you read one article about etiquette in 2019 and stopped there.",
  "You hit the middle lane and stayed there. Very on-brand for a Tuesday.",
  "You tipped like you read one article about etiquette in 2020 and stopped there.",
  "You tipped like you read one article about etiquette in 2021 and stopped there.",
  "You tipped like you read one article about etiquette in 2022 and stopped there.",
  "You tipped like you read one article about etiquette in 2023 and stopped there.",
  "You tipped like you were paying a toll you did not owe then left a review about \"atmosphere.\"",
  "That gratuity with energy that screams \"I read the bill wrong on purpose\" which is why we built this app.",
  "The server saw your total and like the pour was personal but the tip was not and thought nobody would notice.",
  "Your bill was fine but your tip as though kindness were taxed and you filed an extension then asked if water refills are free.",
  "The bartender ran the card and like you thought autograt was a suggestion and moved on without learning.",
  "On this tab you with a percentage that belongs on a warning label then asked for the Wi-Fi password.",
  "Tonight you left like the food was good but humanity was extra like that was the whole personality.",
  "The math said twenty percent but you as if rounding down were a sport so the staff will remember you anyway.",
  "Your receipt tells a story where you like you tipped with vibes instead of dollars and called it budgeting.",
  "The industry notes that you with the audacity of a person who snaps at the register then wondered why the refills stopped.",
  "History will remember that you like the service was optional which is a choice you will defend online.",
  "The tip line says you like generosity was a limited-time offer you missed and still ordered dessert.",
  "Your wallet whispered but you like the night was great until the tip then tipped on the post-tax total incorrectly.",
  "Common decency arrived and you with the confidence of someone who never worked a shift like shame was not on the menu.",
  "The calculator cried when you as if the server was part of the furniture and blamed the economy.",
  "Twenty-ish percent at the bar — respectable, forgettable, very you.",
  "Twenty-ish percent at the pub — respectable, forgettable, very you.",
  "Twenty-ish percent at the restaurant — respectable, forgettable, very you.",
  "Twenty-ish percent at the dive — respectable, forgettable, very you.",
  "Twenty-ish percent at the spot — respectable, forgettable, very you.",
  "Twenty-ish percent at the joint — respectable, forgettable, very you.",
  "Twenty-ish percent at the room — respectable, forgettable, very you.",
  "Twenty-ish percent at the counter — respectable, forgettable, very you.",
  "Twenty-ish percent at the booth — respectable, forgettable, very you.",
  "Twenty-ish percent at the patio — respectable, forgettable, very you.",
  "So Twenty-ish percent at the bar — respectable, forgettable, very you.",
  "So Twenty-ish percent at the pub — respectable, forgettable, very you.",
  "So Twenty-ish percent at the restaurant — respectable, forgettable, very you.",
  "So Twenty-ish percent at the dive — respectable, forgettable, very you.",
  "So Twenty-ish percent at the spot — respectable, forgettable, very you.",
  "So Twenty-ish percent at the joint — respectable, forgettable, very you.",
  "So Twenty-ish percent at the room — respectable, forgettable, very you.",
  "So Twenty-ish percent at the counter — respectable, forgettable, very you.",
  "So Twenty-ish percent at the booth — respectable, forgettable, very you.",
  "So Twenty-ish percent at the patio — respectable, forgettable, very you.",
  "Apparently Twenty-ish percent at the bar — respectable, forgettable, very you.",
  "Apparently Twenty-ish percent at the pub — respectable, forgettable, very you.",
  "Apparently Twenty-ish percent at the restaurant — respectable, forgettable, very you.",
  "Apparently Twenty-ish percent at the dive — respectable, forgettable, very you.",
  "Apparently Twenty-ish percent at the spot — respectable, forgettable, very you.",
  "Apparently Twenty-ish percent at the joint — respectable, forgettable, very you.",
  "Apparently Twenty-ish percent at the room — respectable, forgettable, very you.",
  "Apparently Twenty-ish percent at the counter — respectable, forgettable, very you.",
  "Apparently Twenty-ish percent at the booth — respectable, forgettable, very you.",
  "Apparently Twenty-ish percent at the patio — respectable, forgettable, very you.",
  "Classic move: Twenty-ish percent at the bar — respectable, forgettable, very you.",
  "Classic move: Twenty-ish percent at the pub — respectable, forgettable, very you.",
  "Classic move: Twenty-ish percent at the restaurant — respectable, forgettable, very you.",
  "Classic move: Twenty-ish percent at the dive — respectable, forgettable, very you.",
  "Classic move: Twenty-ish percent at the spot — respectable, forgettable, very you.",
  "Classic move: Twenty-ish percent at the joint — respectable, forgettable, very you.",
  "Classic move: Twenty-ish percent at the room — respectable, forgettable, very you.",
  "Classic move: Twenty-ish percent at the counter — respectable, forgettable, very you.",
  "Classic move: Twenty-ish percent at the booth — respectable, forgettable, very you.",
  "Classic move: Twenty-ish percent at the patio — respectable, forgettable, very you.",
  "Statistically, Twenty-ish percent at the bar — respectable, forgettable, very you.",
  "Statistically, Twenty-ish percent at the pub — respectable, forgettable, very you.",
  "Statistically, Twenty-ish percent at the restaurant — respectable, forgettable, very you.",
  "Statistically, Twenty-ish percent at the dive — respectable, forgettable, very you.",
  "Statistically, Twenty-ish percent at the spot — respectable, forgettable, very you.",
  "Statistically, Twenty-ish percent at the joint — respectable, forgettable, very you.",
  "Statistically, Twenty-ish percent at the room — respectable, forgettable, very you.",
  "Statistically, Twenty-ish percent at the counter — respectable, forgettable, very you.",
  "Statistically, Twenty-ish percent at the booth — respectable, forgettable, very you.",
  "Statistically, Twenty-ish percent at the patio — respectable, forgettable, very you.",
  "Historically, Twenty-ish percent at the bar — respectable, forgettable, very you.",
]

export const GENEROUS_LINES: readonly string[] = [
  "Was the bartender cute, or did they actually save your night?",
  "Twenty-five percent. Either the service was elite or you are hoping they remember your name.",
  "That is not a tip. That is a love letter with a dollar sign.",
  "Was it the pour, the smile, or the third cocktail talking?",
  "Generous. Tell us it was the service. We will pretend to believe you.",
  "Did they really do a great job, or did you just like being looked at?",
  "That tip is doing a lot of talking. The receipt cannot blush.",
  "You tipped like you want a regulars tab and a knowing nod.",
  "Twenty-five percent. Either excellent service or excellent eye contact. Possibly both.",
  "You tipped like you are trying to become someone's favorite problem.",
  "That gratuity has main-character energy and a side of flirting.",
  "Generous enough that the staff will gossip kindly about you.",
  "Was the cocktail strong, or was the bartender stronger?",
  "You tipped like you want them to remember your order and your aura.",
  "That is not standard. That is \"I had a night\" math.",
  "You left a tip that suggests hope, hormones, or both.",
  "The service was good. Your tip says it was a movie.",
  "You tipped like someone who might come back tomorrow and pretend it was an accident.",
  "Twenty-five percent is what you leave when the conversation was better than the food.",
  "You tipped like a regular before you earned regular status.",
  "That percentage whispers \"call me\" in accounting language.",
  "You were generous. The question is whether it was gratitude or strategy.",
  "You tipped like the bartender fixed your week, not just your drink.",
  "High tip, high drama potential. We respect the commitment.",
  "You tipped like you want the good ice next time.",
  "That is the tip you leave when you are already planning round two.",
  "Generous. Either they earned it or you are easily charmed. No judgment. Some judgment.",
  "You tipped like the smile was part of the service package. Premium tier.",
  "You tipped like you were paying a toll you did not owe then left a review about \"atmosphere.\"",
  "That gratuity with energy that screams \"I read the bill wrong on purpose\" which is why we built this app.",
  "The server saw your total and like the pour was personal but the tip was not and thought nobody would notice.",
  "Your bill was fine but your tip as though kindness were taxed and you filed an extension then asked if water refills are free.",
  "The bartender ran the card and like you thought autograt was a suggestion and moved on without learning.",
  "On this tab you with a percentage that belongs on a warning label then asked for the Wi-Fi password.",
  "Tonight you left like the food was good but humanity was extra like that was the whole personality.",
  "The math said twenty percent but you as if rounding down were a sport so the staff will remember you anyway.",
  "Your receipt tells a story where you like you tipped with vibes instead of dollars and called it budgeting.",
  "The industry notes that you with the audacity of a person who snaps at the register then wondered why the refills stopped.",
  "History will remember that you like the service was optional which is a choice you will defend online.",
  "The tip line says you like generosity was a limited-time offer you missed and still ordered dessert.",
  "Your wallet whispered but you like the night was great until the tip then tipped on the post-tax total incorrectly.",
  "Common decency arrived and you with the confidence of someone who never worked a shift like shame was not on the menu.",
  "The calculator cried when you as if the server was part of the furniture and blamed the economy.",
  "25% at the bar — service, crush, or cocktail math.",
  "26% at the pub — service, crush, or cocktail math.",
  "27% at the restaurant — service, crush, or cocktail math.",
  "28% at the dive — service, crush, or cocktail math.",
  "29% at the spot — service, crush, or cocktail math.",
  "25% at the joint — service, crush, or cocktail math.",
  "26% at the room — service, crush, or cocktail math.",
  "27% at the counter — service, crush, or cocktail math.",
  "28% at the booth — service, crush, or cocktail math.",
  "29% at the patio — service, crush, or cocktail math.",
  "So 25% at the bar — service, crush, or cocktail math.",
  "So 26% at the pub — service, crush, or cocktail math.",
  "So 27% at the restaurant — service, crush, or cocktail math.",
  "So 28% at the dive — service, crush, or cocktail math.",
  "So 29% at the spot — service, crush, or cocktail math.",
  "So 25% at the joint — service, crush, or cocktail math.",
  "So 26% at the room — service, crush, or cocktail math.",
  "So 27% at the counter — service, crush, or cocktail math.",
  "So 28% at the booth — service, crush, or cocktail math.",
  "So 29% at the patio — service, crush, or cocktail math.",
  "Apparently 25% at the bar — service, crush, or cocktail math.",
  "Apparently 26% at the pub — service, crush, or cocktail math.",
  "Apparently 27% at the restaurant — service, crush, or cocktail math.",
  "Apparently 28% at the dive — service, crush, or cocktail math.",
  "Apparently 29% at the spot — service, crush, or cocktail math.",
  "Apparently 25% at the joint — service, crush, or cocktail math.",
  "Apparently 26% at the room — service, crush, or cocktail math.",
  "Apparently 27% at the counter — service, crush, or cocktail math.",
  "Apparently 28% at the booth — service, crush, or cocktail math.",
  "Apparently 29% at the patio — service, crush, or cocktail math.",
  "Classic move: 25% at the bar — service, crush, or cocktail math.",
  "Classic move: 26% at the pub — service, crush, or cocktail math.",
  "Classic move: 27% at the restaurant — service, crush, or cocktail math.",
  "Classic move: 28% at the dive — service, crush, or cocktail math.",
  "Classic move: 29% at the spot — service, crush, or cocktail math.",
  "Classic move: 25% at the joint — service, crush, or cocktail math.",
  "Classic move: 26% at the room — service, crush, or cocktail math.",
  "Classic move: 27% at the counter — service, crush, or cocktail math.",
  "Classic move: 28% at the booth — service, crush, or cocktail math.",
  "Classic move: 29% at the patio — service, crush, or cocktail math.",
  "Statistically, 25% at the bar — service, crush, or cocktail math.",
  "Statistically, 26% at the pub — service, crush, or cocktail math.",
  "Statistically, 27% at the restaurant — service, crush, or cocktail math.",
  "Statistically, 28% at the dive — service, crush, or cocktail math.",
  "Statistically, 29% at the spot — service, crush, or cocktail math.",
  "Statistically, 25% at the joint — service, crush, or cocktail math.",
  "Statistically, 26% at the room — service, crush, or cocktail math.",
  "Statistically, 27% at the counter — service, crush, or cocktail math.",
  "Statistically, 28% at the booth — service, crush, or cocktail math.",
  "Statistically, 29% at the patio — service, crush, or cocktail math.",
  "Historically, 25% at the bar — service, crush, or cocktail math.",
  "Historically, 26% at the pub — service, crush, or cocktail math.",
  "Historically, 27% at the restaurant — service, crush, or cocktail math.",
  "Historically, 28% at the dive — service, crush, or cocktail math.",
  "Historically, 29% at the spot — service, crush, or cocktail math.",
  "Historically, 25% at the joint — service, crush, or cocktail math.",
  "Historically, 26% at the room — service, crush, or cocktail math.",
]

export const EXTRA_LINES: readonly string[] = [
  "Thirty percent. Write your number on the receipt while you are at it.",
  "Was it the service, the smile, or the last round making the decisions?",
  "That is a proposal, not a gratuity.",
  "The server is going to tell this story. You are the plot twist.",
  "You tipped like someone who is never coming back, or someone who definitely is.",
  "Easy there. They brought you nachos, not a kidney.",
  "If this is how you tip when they are cute, what happens when they are competent too?",
  "That percentage needs a chaperone.",
  "Thirty percent. At that point just hire them as your emotional support bartender.",
  "You tipped like money is a love language and you are fluent tonight.",
  "That gratuity could fund a small vacation for one very confused server.",
  "You did not tip. You sponsored a shift.",
  "Thirty percent is what you leave when the night was illegal in the best way.",
  "You tipped like you lost a bet with yourself.",
  "That is not generosity. That is a down payment on future favoritism.",
  "You tipped like the receipt was a fan club membership.",
  "The math says you had fun. The tip says you had feelings.",
  "You tipped like you want them to remember your name and your trauma.",
  "Thirty percent. The industry will talk about you. So will your bank app.",
  "You tipped like the last round was your co-pilot.",
  "That percentage needs its own zip code.",
  "You tipped like you are either filthy rich or filthy charming. Maybe both.",
  "Easy, cowboy. It is a bar tab, not a dowry.",
  "You left a tip that could buy another round for the staff to laugh about you.",
  "Thirty percent is what happens when the eyes meet and the brain leaves.",
  "You tipped like gratitude and poor impulse control held hands.",
  "That is a hero tip for a night that might not deserve hero pricing.",
  "You tipped like you want VIP status in a place with no VIP section.",
  "You tipped like you were paying a toll you did not owe then left a review about \"atmosphere.\"",
  "That gratuity with energy that screams \"I read the bill wrong on purpose\" which is why we built this app.",
  "The server saw your total and like the pour was personal but the tip was not and thought nobody would notice.",
  "Your bill was fine but your tip as though kindness were taxed and you filed an extension then asked if water refills are free.",
  "The bartender ran the card and like you thought autograt was a suggestion and moved on without learning.",
  "On this tab you with a percentage that belongs on a warning label then asked for the Wi-Fi password.",
  "Tonight you left like the food was good but humanity was extra like that was the whole personality.",
  "The math said twenty percent but you as if rounding down were a sport so the staff will remember you anyway.",
  "Your receipt tells a story where you like you tipped with vibes instead of dollars and called it budgeting.",
  "The industry notes that you with the audacity of a person who snaps at the register then wondered why the refills stopped.",
  "History will remember that you like the service was optional which is a choice you will defend online.",
  "The tip line says you like generosity was a limited-time offer you missed and still ordered dessert.",
  "Your wallet whispered but you like the night was great until the tip then tipped on the post-tax total incorrectly.",
  "Common decency arrived and you with the confidence of someone who never worked a shift like shame was not on the menu.",
  "The calculator cried when you as if the server was part of the furniture and blamed the economy.",
  "30% at the bar — down payment on future favoritism.",
  "31% at the pub — down payment on future favoritism.",
  "32% at the restaurant — down payment on future favoritism.",
  "33% at the dive — down payment on future favoritism.",
  "30% at the spot — down payment on future favoritism.",
  "31% at the joint — down payment on future favoritism.",
  "32% at the room — down payment on future favoritism.",
  "33% at the counter — down payment on future favoritism.",
  "30% at the booth — down payment on future favoritism.",
  "31% at the patio — down payment on future favoritism.",
  "So 32% at the bar — down payment on future favoritism.",
  "So 33% at the pub — down payment on future favoritism.",
  "So 30% at the restaurant — down payment on future favoritism.",
  "So 31% at the dive — down payment on future favoritism.",
  "So 32% at the spot — down payment on future favoritism.",
  "So 33% at the joint — down payment on future favoritism.",
  "So 30% at the room — down payment on future favoritism.",
  "So 31% at the counter — down payment on future favoritism.",
  "So 32% at the booth — down payment on future favoritism.",
  "So 33% at the patio — down payment on future favoritism.",
  "Apparently 30% at the bar — down payment on future favoritism.",
  "Apparently 31% at the pub — down payment on future favoritism.",
  "Apparently 32% at the restaurant — down payment on future favoritism.",
  "Apparently 33% at the dive — down payment on future favoritism.",
  "Apparently 30% at the spot — down payment on future favoritism.",
  "Apparently 31% at the joint — down payment on future favoritism.",
  "Apparently 32% at the room — down payment on future favoritism.",
  "Apparently 33% at the counter — down payment on future favoritism.",
  "Apparently 30% at the booth — down payment on future favoritism.",
  "Apparently 31% at the patio — down payment on future favoritism.",
  "Classic move: 32% at the bar — down payment on future favoritism.",
  "Classic move: 33% at the pub — down payment on future favoritism.",
  "Classic move: 30% at the restaurant — down payment on future favoritism.",
  "Classic move: 31% at the dive — down payment on future favoritism.",
  "Classic move: 32% at the spot — down payment on future favoritism.",
  "Classic move: 33% at the joint — down payment on future favoritism.",
  "Classic move: 30% at the room — down payment on future favoritism.",
  "Classic move: 31% at the counter — down payment on future favoritism.",
  "Classic move: 32% at the booth — down payment on future favoritism.",
  "Classic move: 33% at the patio — down payment on future favoritism.",
  "Statistically, 30% at the bar — down payment on future favoritism.",
  "Statistically, 31% at the pub — down payment on future favoritism.",
  "Statistically, 32% at the restaurant — down payment on future favoritism.",
  "Statistically, 33% at the dive — down payment on future favoritism.",
  "Statistically, 30% at the spot — down payment on future favoritism.",
  "Statistically, 31% at the joint — down payment on future favoritism.",
  "Statistically, 32% at the room — down payment on future favoritism.",
  "Statistically, 33% at the counter — down payment on future favoritism.",
  "Statistically, 30% at the booth — down payment on future favoritism.",
  "Statistically, 31% at the patio — down payment on future favoritism.",
  "Historically, 32% at the bar — down payment on future favoritism.",
  "Historically, 33% at the pub — down payment on future favoritism.",
  "Historically, 30% at the restaurant — down payment on future favoritism.",
  "Historically, 31% at the dive — down payment on future favoritism.",
  "Historically, 32% at the spot — down payment on future favoritism.",
  "Historically, 33% at the joint — down payment on future favoritism.",
  "Historically, 30% at the room — down payment on future favoritism.",
]

export const EMPTY_LINES: readonly string[] = [
  "No tabs yet. Either you are responsible, or you are lying.",
  "Empty history. Log a bill or we will assume you drink at home in silence.",
  "Nothing logged. The app cannot roast a ghost.",
  "Scan a receipt. Manual entry counts too. Cowardice does not.",
  "Zero tabs logged. The roast engine is idle and judging you anyway.",
  "You opened a tip calculator with nothing to calculate. Bold.",
  "No history yet. Either new here or deleting evidence.",
  "The ledger is empty. Your liver might not be. Log something.",
  "Nothing saved. We cannot shame what we cannot see. Help us help you.",
  "No tabs. Are you cooking at home or just avoiding accountability?",
  "Empty app, full mystery. Tap save on something real.",
  "You have not logged a single night out. Suspiciously wholesome or suspiciously lazy.",
  "No data, no drama. Fix that.",
  "The history tab is a desert. Go hydrate it with bad decisions.",
  "Still at zero tabs. The app is not mad. It is disappointed.",
  "Nothing to analyze yet. Go be interesting in public.",
  "Your tab history is cleaner than your conscience probably is not.",
  "Log a bill or admit you only eat gas station sandwiches in the car.",
  "No entries. The roast card is starving.",
  "You downloaded a shame app and gave it nothing to work with. Classic.",
  "Empty history is a choice. So is going out tonight.",
  "We cannot roast air. Type a number.",
  "Zero tabs means zero proof you ever leave the house.",
  "Start logging or we will assume you tip in thoughts and prayers.",
  "Still no tabs logged. The app is waiting like a patient bartender.",
  "Nothing saved yet. The roast card is pacing.",
  "Zero tabs on the books. Suspicious or saintly — pick one.",
  "No history yet. Go log something before we get creative.",
  "You opened a shame app and gave it nothing to work with.",
  "The ledger is empty. Your liver might not be.",
  "No tabs saved. We cannot roast what we cannot see.",
  "Start logging or we will assume you only eat in the car.",
  "Empty history is a flex until it is not.",
  "Tap save on a real bill. The roasts are bored.",
  "So You have not logged a single night out. Interesting.",
  "So The app is idle and judgmental.",
  "So No entries yet. Go be interesting in public.",
  "So Zero data, maximum mystery.",
  "So Log a tab or admit you tip in thoughts and prayers.",
  "So Nothing here yet except potential.",
  "So Save a bill. Help the algorithm help you.",
  "So Your history is cleaner than a new notebook.",
  "So No tabs means no proof of generosity or crimes.",
  "So The shame engine needs fuel. Type a number.",
  "Apparently Still no tabs logged. The app is waiting like a patient bartender.",
  "Apparently Nothing saved yet. The roast card is pacing.",
  "Apparently Zero tabs on the books. Suspicious or saintly — pick one.",
  "Apparently No history yet. Go log something before we get creative.",
  "Apparently You opened a shame app and gave it nothing to work with.",
  "Apparently The ledger is empty. Your liver might not be.",
  "Apparently No tabs saved. We cannot roast what we cannot see.",
  "Apparently Start logging or we will assume you only eat in the car.",
  "Apparently Empty history is a flex until it is not.",
  "Apparently Tap save on a real bill. The roasts are bored.",
  "Classic move: You have not logged a single night out. Interesting.",
  "Classic move: The app is idle and judgmental.",
  "Classic move: No entries yet. Go be interesting in public.",
  "Classic move: Zero data, maximum mystery.",
  "Classic move: Log a tab or admit you tip in thoughts and prayers.",
  "Classic move: Nothing here yet except potential.",
  "Classic move: Save a bill. Help the algorithm help you.",
  "Classic move: Your history is cleaner than a new notebook.",
  "Classic move: No tabs means no proof of generosity or crimes.",
  "Classic move: The shame engine needs fuel. Type a number.",
  "Statistically, Still no tabs logged. The app is waiting like a patient bartender.",
  "Statistically, Nothing saved yet. The roast card is pacing.",
  "Statistically, Zero tabs on the books. Suspicious or saintly — pick one.",
  "Statistically, No history yet. Go log something before we get creative.",
  "Statistically, You opened a shame app and gave it nothing to work with.",
  "Statistically, The ledger is empty. Your liver might not be.",
  "Statistically, No tabs saved. We cannot roast what we cannot see.",
  "Statistically, Start logging or we will assume you only eat in the car.",
  "Statistically, Empty history is a flex until it is not.",
  "Statistically, Tap save on a real bill. The roasts are bored.",
  "Historically, You have not logged a single night out. Interesting.",
  "Historically, The app is idle and judgmental.",
  "Historically, No entries yet. Go be interesting in public.",
  "Historically, Zero data, maximum mystery.",
  "Historically, Log a tab or admit you tip in thoughts and prayers.",
  "Historically, Nothing here yet except potential.",
  "Historically, Save a bill. Help the algorithm help you.",
  "Historically, Your history is cleaner than a new notebook.",
  "Historically, No tabs means no proof of generosity or crimes.",
  "Historically, The shame engine needs fuel. Type a number.",
  "Tonight, Still no tabs logged. The app is waiting like a patient bartender.",
  "Tonight, Nothing saved yet. The roast card is pacing.",
  "Tonight, Zero tabs on the books. Suspicious or saintly — pick one.",
  "Tonight, No history yet. Go log something before we get creative.",
  "Tonight, You opened a shame app and gave it nothing to work with.",
  "Tonight, The ledger is empty. Your liver might not be.",
  "Tonight, No tabs saved. We cannot roast what we cannot see.",
  "Tonight, Start logging or we will assume you only eat in the car.",
  "Tonight, Empty history is a flex until it is not.",
  "Tonight, Tap save on a real bill. The roasts are bored.",
  "Again — You have not logged a single night out. Interesting.",
  "Again — The app is idle and judgmental.",
  "Again — No entries yet. Go be interesting in public.",
  "Again — Zero data, maximum mystery.",
  "Again — Log a tab or admit you tip in thoughts and prayers.",
  "Again — Nothing here yet except potential.",
]

export const NAVIGATOR_DRIVE_HOME_LINES: readonly string[] = [
  "That tab is doing numbers. Have you tried Navigator of Shame? GPS with a built-in sobriety check before you drive home. Tap the banner at the top to test it.",
  "Big night on the bill. Navigator of Shame is our GPS — it roasts your turns and includes a sobriety check so you know if you should be driving. Banner at the top. Try it.",
  "You did not need another round; you needed a plan home. Navigator of Shame: turn-by-turn with a sobriety check built in. Tap the Shame Logic ad at the top.",
  "Tab that size and you are one bad decision away from a group chat. Navigator of Shame checks whether you are good to drive. Hit the banner up top.",
  "The math says you had fun. The responsible move is Navigator of Shame — GPS plus a sobriety check before you keys-up. Banner at the top when you are done here.",
  "That is a serious tab. Before you drive, try Navigator of Shame — our GPS with a sobriety check. Banner at the top.",
  "Bill that big usually means brain that fuzzy. Navigator of Shame roasts your route and checks if you should drive. Tap the house ad.",
  "You did the spending part. Do the getting-home-safe part. Navigator of Shame is in the banner — GPS plus sobriety check.",
  "Large tab energy detected. Keys later. Navigator of Shame first — turn-by-turn and a sober-second-opinion. Top banner.",
  "Your total says \"party.\" Your drive home should not say \"headline.\" Navigator of Shame — banner at top.",
  "That receipt is a red flag on wheels waiting to happen. Navigator of Shame checks you before you roll. Shame Logic ad up top.",
  "Fun night, scary math. Open Navigator of Shame from the banner — GPS that includes a sobriety check.",
  "Before you Uber your dignity home in your own car, try Navigator of Shame. Banner link. Sobriety check included.",
  "Tab like that and you need more than math — you need Navigator of Shame. GPS plus \"should I drive\" honesty. Top ad.",
  "The responsible flex is not tipping more. It is checking yourself. Navigator of Shame — tap the banner.",
  "Big bill, bigger judgment call. Navigator of Shame: roasted directions and a sobriety check. House ad at top.",
  "You counted the tip. Count whether you are safe to drive. Navigator of Shame in the Shame Logic banner.",
  "That total could buy a rideshare and a lecture. Or tap Navigator of Shame and get GPS with accountability.",
  "Closing time is not a strategy. Navigator of Shame is — banner at top, sobriety check built in.",
  "Your tab is loud. Make sure your drive home is not. Navigator of Shame — try it from the banner.",
  "Spent enough to hurt. Do not spend tomorrow on a DUI story. Navigator of Shame — top banner.",
  "The night went well. The drive home is the boss fight. Navigator of Shame — GPS plus sobriety check. Banner.",
  "That is a \"call a friend\" tab unless you check yourself first. Navigator of Shame — Shame Logic ad up top.",
  "Hydrate, breathe, then open Navigator of Shame from the banner before you touch the keys.",
  "Tab of Shame did the math. Navigator of Shame does the \"am I okay to drive\" part. Link at the top.",
  "Tab got big enough to matter. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the bar.",
  "That total is loud tonight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the pub.",
  "Big bill, bigger judgment call. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the restaurant.",
  "The math says you had fun. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the dive.",
  "Serious tab energy detected. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the spot.",
  "You spent like the night has a sequel. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the joint.",
  "That receipt is flirting with regret. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the room.",
  "Closing time is not a financial plan. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the counter.",
  "Your tab is doing main-character numbers. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the booth.",
  "Fun was had. Driving home is the boss fight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the patio.",
  "So Tab got big enough to matter. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the bar.",
  "So That total is loud tonight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the pub.",
  "So Big bill, bigger judgment call. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the restaurant.",
  "So The math says you had fun. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the dive.",
  "So Serious tab energy detected. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the spot.",
  "So You spent like the night has a sequel. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the joint.",
  "So That receipt is flirting with regret. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the room.",
  "So Closing time is not a financial plan. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the counter.",
  "So Your tab is doing main-character numbers. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the booth.",
  "So Fun was had. Driving home is the boss fight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the patio.",
  "Apparently Tab got big enough to matter. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the bar.",
  "Apparently That total is loud tonight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the pub.",
  "Apparently Big bill, bigger judgment call. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the restaurant.",
  "Apparently The math says you had fun. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the dive.",
  "Apparently Serious tab energy detected. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the spot.",
  "Apparently You spent like the night has a sequel. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the joint.",
  "Apparently That receipt is flirting with regret. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the room.",
  "Apparently Closing time is not a financial plan. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the counter.",
  "Apparently Your tab is doing main-character numbers. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the booth.",
  "Apparently Fun was had. Driving home is the boss fight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the patio.",
  "Classic move: Tab got big enough to matter. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the bar.",
  "Classic move: That total is loud tonight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the pub.",
  "Classic move: Big bill, bigger judgment call. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the restaurant.",
  "Classic move: The math says you had fun. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the dive.",
  "Classic move: Serious tab energy detected. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the spot.",
  "Classic move: You spent like the night has a sequel. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the joint.",
  "Classic move: That receipt is flirting with regret. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the room.",
  "Classic move: Closing time is not a financial plan. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the counter.",
  "Classic move: Your tab is doing main-character numbers. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the booth.",
  "Classic move: Fun was had. Driving home is the boss fight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the patio.",
  "Statistically, Tab got big enough to matter. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the bar.",
  "Statistically, That total is loud tonight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the pub.",
  "Statistically, Big bill, bigger judgment call. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the restaurant.",
  "Statistically, The math says you had fun. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the dive.",
  "Statistically, Serious tab energy detected. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the spot.",
  "Statistically, You spent like the night has a sequel. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the joint.",
  "Statistically, That receipt is flirting with regret. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the room.",
  "Statistically, Closing time is not a financial plan. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the counter.",
  "Statistically, Your tab is doing main-character numbers. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the booth.",
  "Statistically, Fun was had. Driving home is the boss fight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the patio.",
  "Historically, Tab got big enough to matter. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the bar.",
  "Historically, That total is loud tonight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the pub.",
  "Historically, Big bill, bigger judgment call. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the restaurant.",
  "Historically, The math says you had fun. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the dive.",
  "Historically, Serious tab energy detected. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the spot.",
  "Historically, You spent like the night has a sequel. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the joint.",
  "Historically, That receipt is flirting with regret. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the room.",
  "Historically, Closing time is not a financial plan. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the counter.",
  "Historically, Your tab is doing main-character numbers. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the booth.",
  "Historically, Fun was had. Driving home is the boss fight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the patio.",
  "Tonight, Tab got big enough to matter. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the bar.",
  "Tonight, That total is loud tonight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the pub.",
  "Tonight, Big bill, bigger judgment call. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the restaurant.",
  "Tonight, The math says you had fun. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the dive.",
  "Tonight, Serious tab energy detected. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the spot.",
  "Tonight, You spent like the night has a sequel. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the joint.",
  "Tonight, That receipt is flirting with regret. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the room.",
  "Tonight, Closing time is not a financial plan. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the counter.",
  "Tonight, Your tab is doing main-character numbers. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the booth.",
  "Tonight, Fun was had. Driving home is the boss fight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the patio.",
  "Again — Tab got big enough to matter. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the bar.",
  "Again — That total is loud tonight. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the pub.",
  "Again — Big bill, bigger judgment call. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the restaurant.",
  "Again — The math says you had fun. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the dive.",
  "Again — Serious tab energy detected. Navigator of Shame — banner up top — GPS plus sobriety check before you leave the spot.",
]

export const HABIT_HEAVY_WEEK: readonly string[] = [
  "Three or more tabs this week. Your liver filed a complaint. We forwarded it.",
  "You are collecting stamps. The prize is a conversation with your bank.",
  "This week is a pub crawl with extra paperwork.",
  "3 nights out this week. Your calendar is just bar logos now.",
  "You are speed-running the local hospitality industry one tab at a time.",
  "This week looks like a montage without the workout payoff.",
  "Multiple tabs in seven days. Your wallet needs a wellness check.",
  "You did not have a week. You had a tour.",
  "Frequency like this is a hobby with receipts.",
  "Your liver did not sign up for this schedule.",
  "Another tab this week? At this point the bartender is your coworker.",
  "You are treating weekdays like they owe you an apology.",
  "This week is less \"going out\" and more \"going out again.\"",
  "You logged another night. The streak is not the flex you think it is.",
  "Three-plus tabs in a week is a pattern, not an accident.",
  "Your bank app is going to need a content warning.",
  "You are building a portfolio of poor sleep decisions.",
  "This week has more bar dates than your dating app.",
  "You are not social. You are recurring revenue for pubs.",
  "Another week, another stack of tabs. Impressive in the worst way.",
  "You are on a hot streak of cold opens and warm bills.",
  "The week is young and you already need a nap and an intervention.",
  "You did not go out. You went out repeatedly. Grammar matters less than your liver.",
  "You logged another tab downtown — shame ledger entry 1.",
  "4 nights out this week. Your calendar is just bar logos now.",
  "You saved another tab around the corner — shame ledger entry 2.",
  "5 nights out this week. Your calendar is just bar logos now.",
  "You documented another tab where everyone knows you — shame ledger entry 3.",
  "6 nights out this week. Your calendar is just bar logos now.",
  "You celebrated another tab like it is your job — shame ledger entry 4.",
  "You rationalized another tab downtown — shame ledger entry 5.",
  "You logged another tab around the corner — shame ledger entry 6.",
  "You saved another tab where everyone knows you — shame ledger entry 7.",
  "You documented another tab like it is your job — shame ledger entry 8.",
  "You celebrated another tab downtown — shame ledger entry 9.",
  "You rationalized another tab around the corner — shame ledger entry 10.",
  "You logged another tab where everyone knows you — shame ledger entry 11.",
  "You saved another tab like it is your job — shame ledger entry 12.",
  "You documented another tab downtown — shame ledger entry 13.",
  "You celebrated another tab around the corner — shame ledger entry 14.",
  "You rationalized another tab where everyone knows you — shame ledger entry 15.",
  "You logged another tab like it is your job — shame ledger entry 16.",
  "You saved another tab downtown — shame ledger entry 17.",
  "You documented another tab around the corner — shame ledger entry 18.",
  "You celebrated another tab where everyone knows you — shame ledger entry 19.",
  "You rationalized another tab like it is your job — shame ledger entry 20.",
  "You logged another tab downtown — shame ledger entry 21.",
  "You saved another tab around the corner — shame ledger entry 22.",
  "You documented another tab where everyone knows you — shame ledger entry 23.",
  "You celebrated another tab like it is your job — shame ledger entry 24.",
  "You rationalized another tab downtown — shame ledger entry 25.",
  "You logged another tab around the corner — shame ledger entry 26.",
  "You saved another tab where everyone knows you — shame ledger entry 27.",
  "You documented another tab like it is your job — shame ledger entry 28.",
  "You celebrated another tab downtown — shame ledger entry 29.",
  "You rationalized another tab around the corner — shame ledger entry 30.",
  "You logged another tab where everyone knows you — shame ledger entry 31.",
  "You saved another tab like it is your job — shame ledger entry 32.",
  "You documented another tab downtown — shame ledger entry 33.",
  "You celebrated another tab around the corner — shame ledger entry 34.",
  "You rationalized another tab where everyone knows you — shame ledger entry 35.",
  "You logged another tab like it is your job — shame ledger entry 36.",
  "You saved another tab downtown — shame ledger entry 37.",
  "You documented another tab around the corner — shame ledger entry 38.",
  "You celebrated another tab where everyone knows you — shame ledger entry 39.",
  "You rationalized another tab like it is your job — shame ledger entry 40.",
  "You logged another tab downtown — shame ledger entry 41.",
  "You saved another tab around the corner — shame ledger entry 42.",
  "You documented another tab where everyone knows you — shame ledger entry 43.",
  "You celebrated another tab like it is your job — shame ledger entry 44.",
  "You rationalized another tab downtown — shame ledger entry 45.",
  "You logged another tab around the corner — shame ledger entry 46.",
  "You saved another tab where everyone knows you — shame ledger entry 47.",
  "You documented another tab like it is your job — shame ledger entry 48.",
  "You celebrated another tab downtown — shame ledger entry 49.",
  "You rationalized another tab around the corner — shame ledger entry 50.",
  "You logged another tab where everyone knows you — shame ledger entry 51.",
  "You saved another tab like it is your job — shame ledger entry 52.",
  "You documented another tab downtown — shame ledger entry 53.",
  "You celebrated another tab around the corner — shame ledger entry 54.",
  "You rationalized another tab where everyone knows you — shame ledger entry 55.",
  "You logged another tab like it is your job — shame ledger entry 56.",
  "You saved another tab downtown — shame ledger entry 57.",
  "You documented another tab around the corner — shame ledger entry 58.",
  "You celebrated another tab where everyone knows you — shame ledger entry 59.",
  "You rationalized another tab like it is your job — shame ledger entry 60.",
  "You logged another tab downtown — shame ledger entry 61.",
  "You saved another tab around the corner — shame ledger entry 62.",
  "You documented another tab where everyone knows you — shame ledger entry 63.",
  "You celebrated another tab like it is your job — shame ledger entry 64.",
  "You rationalized another tab downtown — shame ledger entry 65.",
  "You logged another tab around the corner — shame ledger entry 66.",
  "You saved another tab where everyone knows you — shame ledger entry 67.",
  "You documented another tab like it is your job — shame ledger entry 68.",
  "You celebrated another tab downtown — shame ledger entry 69.",
  "You rationalized another tab around the corner — shame ledger entry 70.",
  "You logged another tab where everyone knows you — shame ledger entry 71.",
  "You saved another tab like it is your job — shame ledger entry 72.",
  "You documented another tab downtown — shame ledger entry 73.",
  "You celebrated another tab around the corner — shame ledger entry 74.",
]

export const HABIT_HEAVY_SPEND: readonly string[] = [
  "You have spent more on tabs this week than some people spend on groceries.",
  "That weekly total is a car payment with worse judgment.",
  "The bars are doing fine. Your checking account asked us to intervene.",
  "Your weekly spend could fund a vacation you will be too tired to take.",
  "That total is what happens when \"just one drink\" lies for a living.",
  "You tipped the economy and taxed your future self.",
  "The math this week is loud. So is your notification sound probably.",
  "You spent like the weekend was a limited-time offer.",
  "Your tab total this week has main-character energy and side-character budgeting.",
  "That is not dining out. That is leasing a stool.",
  "Your checking account called. We sent it to voicemail.",
  "Weekly spend like this needs its own spreadsheet and a therapist.",
  "You are subsidizing the rent of every bar you touch.",
  "The industry loves you. Your savings account does not.",
  "You spent enough this week to forget at least three of the nights.",
  "That weekly total is a flex until rent is due.",
  "You did not buy groceries. You bought vibes with surcharges.",
  "Your out-the-door number this week could buy a very nice blender you will not use.",
  "High spend, low mystery. We see the pattern.",
  "You are running a tab on life and the interest is shame.",
  "Weekly damage report: expensive and documented.",
  "You spent like tips are optional and regret is not.",
  "That is a car note worth of \"I deserved it.\" Did you?",
  "You logged another tab downtown — shame ledger entry 1.",
  "You saved another tab around the corner — shame ledger entry 2.",
  "You documented another tab where everyone knows you — shame ledger entry 3.",
  "You celebrated another tab like it is your job — shame ledger entry 4.",
  "You rationalized another tab downtown — shame ledger entry 5.",
  "You logged another tab around the corner — shame ledger entry 6.",
  "You saved another tab where everyone knows you — shame ledger entry 7.",
  "You documented another tab like it is your job — shame ledger entry 8.",
  "You celebrated another tab downtown — shame ledger entry 9.",
  "You rationalized another tab around the corner — shame ledger entry 10.",
  "You logged another tab where everyone knows you — shame ledger entry 11.",
  "You saved another tab like it is your job — shame ledger entry 12.",
  "You documented another tab downtown — shame ledger entry 13.",
  "You celebrated another tab around the corner — shame ledger entry 14.",
  "You rationalized another tab where everyone knows you — shame ledger entry 15.",
  "You logged another tab like it is your job — shame ledger entry 16.",
  "You saved another tab downtown — shame ledger entry 17.",
  "You documented another tab around the corner — shame ledger entry 18.",
  "You celebrated another tab where everyone knows you — shame ledger entry 19.",
  "You rationalized another tab like it is your job — shame ledger entry 20.",
  "You logged another tab downtown — shame ledger entry 21.",
  "You saved another tab around the corner — shame ledger entry 22.",
  "You documented another tab where everyone knows you — shame ledger entry 23.",
  "You celebrated another tab like it is your job — shame ledger entry 24.",
  "You rationalized another tab downtown — shame ledger entry 25.",
  "You logged another tab around the corner — shame ledger entry 26.",
  "You saved another tab where everyone knows you — shame ledger entry 27.",
  "You documented another tab like it is your job — shame ledger entry 28.",
  "You celebrated another tab downtown — shame ledger entry 29.",
  "You rationalized another tab around the corner — shame ledger entry 30.",
  "You logged another tab where everyone knows you — shame ledger entry 31.",
  "You saved another tab like it is your job — shame ledger entry 32.",
  "You documented another tab downtown — shame ledger entry 33.",
  "You celebrated another tab around the corner — shame ledger entry 34.",
  "You rationalized another tab where everyone knows you — shame ledger entry 35.",
  "You logged another tab like it is your job — shame ledger entry 36.",
  "You saved another tab downtown — shame ledger entry 37.",
  "You documented another tab around the corner — shame ledger entry 38.",
  "You celebrated another tab where everyone knows you — shame ledger entry 39.",
  "You rationalized another tab like it is your job — shame ledger entry 40.",
  "You logged another tab downtown — shame ledger entry 41.",
  "You saved another tab around the corner — shame ledger entry 42.",
  "You documented another tab where everyone knows you — shame ledger entry 43.",
  "You celebrated another tab like it is your job — shame ledger entry 44.",
  "You rationalized another tab downtown — shame ledger entry 45.",
  "You logged another tab around the corner — shame ledger entry 46.",
  "You saved another tab where everyone knows you — shame ledger entry 47.",
  "You documented another tab like it is your job — shame ledger entry 48.",
  "You celebrated another tab downtown — shame ledger entry 49.",
  "You rationalized another tab around the corner — shame ledger entry 50.",
  "You logged another tab where everyone knows you — shame ledger entry 51.",
  "You saved another tab like it is your job — shame ledger entry 52.",
  "You documented another tab downtown — shame ledger entry 53.",
  "You celebrated another tab around the corner — shame ledger entry 54.",
  "You rationalized another tab where everyone knows you — shame ledger entry 55.",
  "You logged another tab like it is your job — shame ledger entry 56.",
  "You saved another tab downtown — shame ledger entry 57.",
  "You documented another tab around the corner — shame ledger entry 58.",
  "You celebrated another tab where everyone knows you — shame ledger entry 59.",
  "You rationalized another tab like it is your job — shame ledger entry 60.",
  "You logged another tab downtown — shame ledger entry 61.",
  "You saved another tab around the corner — shame ledger entry 62.",
  "You documented another tab where everyone knows you — shame ledger entry 63.",
  "You celebrated another tab like it is your job — shame ledger entry 64.",
  "You rationalized another tab downtown — shame ledger entry 65.",
  "You logged another tab around the corner — shame ledger entry 66.",
  "You saved another tab where everyone knows you — shame ledger entry 67.",
  "You documented another tab like it is your job — shame ledger entry 68.",
  "You celebrated another tab downtown — shame ledger entry 69.",
  "You rationalized another tab around the corner — shame ledger entry 70.",
  "You logged another tab where everyone knows you — shame ledger entry 71.",
  "You saved another tab like it is your job — shame ledger entry 72.",
  "You documented another tab downtown — shame ledger entry 73.",
  "You celebrated another tab around the corner — shame ledger entry 74.",
  "You rationalized another tab where everyone knows you — shame ledger entry 75.",
  "You logged another tab like it is your job — shame ledger entry 76.",
  "You saved another tab downtown — shame ledger entry 77.",
]

export const HABIT_CHEAP_PATTERN: readonly string[] = [
  "A pattern of cheap tips is not a personality. It is a warning label.",
  "You keep tipping like the menu prices were a personal attack.",
  "Several stiff nights in a row. The industry has a group chat.",
  "Half your recent tabs are under eighteen percent. That is a lifestyle choice.",
  "You tip like every bill is negotiable and every server is optional.",
  "Cheap again. At this point it is branding.",
  "Your history reads like a masterclass in shortchanging people who smiled at you.",
  "Multiple low tips in a row. The pattern is louder than any single night.",
  "You are not unlucky at math. You are committed to the bit.",
  "The staff would recognize your card and your percentage. Both are memorable.",
  "You keep leaving tips that say \"I was there\" but not \"thank you.\"",
  "Cheap tips stacking up like bad habits with better stories.",
  "Your average kindness is below your average bill. Fix one of those.",
  "You tip like generosity is seasonal and the season is never.",
  "Another sub-eighteen tab logged. The roast writes itself.",
  "You are consistent. Consistently disappointing on the tip line.",
  "The industry remembers repeat customers. Especially the cheap ones.",
  "Your tab history is a crime scene for gratuity.",
  "You did not have one bad tip night. You had a campaign.",
  "Low tips, high frequency. That is worse than one legendary stiff.",
  "You tip like the server was a vending machine that talked back.",
  "Pattern detected: you eat out like an adult and tip like a debate club.",
  "Your recent tabs prove cheap is not a one-time mistake for you.",
  "You logged another tab downtown — shame ledger entry 1.",
  "You saved another tab around the corner — shame ledger entry 2.",
  "You documented another tab where everyone knows you — shame ledger entry 3.",
  "You celebrated another tab like it is your job — shame ledger entry 4.",
  "You rationalized another tab downtown — shame ledger entry 5.",
  "You logged another tab around the corner — shame ledger entry 6.",
  "You saved another tab where everyone knows you — shame ledger entry 7.",
  "You documented another tab like it is your job — shame ledger entry 8.",
  "You celebrated another tab downtown — shame ledger entry 9.",
  "You rationalized another tab around the corner — shame ledger entry 10.",
  "You logged another tab where everyone knows you — shame ledger entry 11.",
  "You saved another tab like it is your job — shame ledger entry 12.",
  "You documented another tab downtown — shame ledger entry 13.",
  "You celebrated another tab around the corner — shame ledger entry 14.",
  "You rationalized another tab where everyone knows you — shame ledger entry 15.",
  "You logged another tab like it is your job — shame ledger entry 16.",
  "You saved another tab downtown — shame ledger entry 17.",
  "You documented another tab around the corner — shame ledger entry 18.",
  "You celebrated another tab where everyone knows you — shame ledger entry 19.",
  "You rationalized another tab like it is your job — shame ledger entry 20.",
  "You logged another tab downtown — shame ledger entry 21.",
  "You saved another tab around the corner — shame ledger entry 22.",
  "You documented another tab where everyone knows you — shame ledger entry 23.",
  "You celebrated another tab like it is your job — shame ledger entry 24.",
  "You rationalized another tab downtown — shame ledger entry 25.",
  "You logged another tab around the corner — shame ledger entry 26.",
  "You saved another tab where everyone knows you — shame ledger entry 27.",
  "You documented another tab like it is your job — shame ledger entry 28.",
  "You celebrated another tab downtown — shame ledger entry 29.",
  "You rationalized another tab around the corner — shame ledger entry 30.",
  "You logged another tab where everyone knows you — shame ledger entry 31.",
  "You saved another tab like it is your job — shame ledger entry 32.",
  "You documented another tab downtown — shame ledger entry 33.",
  "You celebrated another tab around the corner — shame ledger entry 34.",
  "You rationalized another tab where everyone knows you — shame ledger entry 35.",
  "You logged another tab like it is your job — shame ledger entry 36.",
  "You saved another tab downtown — shame ledger entry 37.",
  "You documented another tab around the corner — shame ledger entry 38.",
  "You celebrated another tab where everyone knows you — shame ledger entry 39.",
  "You rationalized another tab like it is your job — shame ledger entry 40.",
  "You logged another tab downtown — shame ledger entry 41.",
  "You saved another tab around the corner — shame ledger entry 42.",
  "You documented another tab where everyone knows you — shame ledger entry 43.",
  "You celebrated another tab like it is your job — shame ledger entry 44.",
  "You rationalized another tab downtown — shame ledger entry 45.",
  "You logged another tab around the corner — shame ledger entry 46.",
  "You saved another tab where everyone knows you — shame ledger entry 47.",
  "You documented another tab like it is your job — shame ledger entry 48.",
  "You celebrated another tab downtown — shame ledger entry 49.",
  "You rationalized another tab around the corner — shame ledger entry 50.",
  "You logged another tab where everyone knows you — shame ledger entry 51.",
  "You saved another tab like it is your job — shame ledger entry 52.",
  "You documented another tab downtown — shame ledger entry 53.",
  "You celebrated another tab around the corner — shame ledger entry 54.",
  "You rationalized another tab where everyone knows you — shame ledger entry 55.",
  "You logged another tab like it is your job — shame ledger entry 56.",
  "You saved another tab downtown — shame ledger entry 57.",
  "You documented another tab around the corner — shame ledger entry 58.",
  "You celebrated another tab where everyone knows you — shame ledger entry 59.",
  "You rationalized another tab like it is your job — shame ledger entry 60.",
  "You logged another tab downtown — shame ledger entry 61.",
  "You saved another tab around the corner — shame ledger entry 62.",
  "You documented another tab where everyone knows you — shame ledger entry 63.",
  "You celebrated another tab like it is your job — shame ledger entry 64.",
  "You rationalized another tab downtown — shame ledger entry 65.",
  "You logged another tab around the corner — shame ledger entry 66.",
  "You saved another tab where everyone knows you — shame ledger entry 67.",
  "You documented another tab like it is your job — shame ledger entry 68.",
  "You celebrated another tab downtown — shame ledger entry 69.",
  "You rationalized another tab around the corner — shame ledger entry 70.",
  "You logged another tab where everyone knows you — shame ledger entry 71.",
  "You saved another tab like it is your job — shame ledger entry 72.",
  "You documented another tab downtown — shame ledger entry 73.",
  "You celebrated another tab around the corner — shame ledger entry 74.",
  "You rationalized another tab where everyone knows you — shame ledger entry 75.",
  "You logged another tab like it is your job — shame ledger entry 76.",
  "You saved another tab downtown — shame ledger entry 77.",
]

export const HABIT_GENEROUS_PATTERN: readonly string[] = [
  "You tip like every bartender is the one. We have questions.",
  "High tips, high frequency. Either the service is elite or you are lonely.",
  "Your average tip says crush. Your calendar says problem.",
  "You keep tipping twenty-five plus like you are always auditioning.",
  "Generous again. The staff must think you are either rich or romantic.",
  "Your history is a series of love letters signed with a percent symbol.",
  "High tips on repeat. Either standards or standards-adjacent delusion.",
  "You tip like every night is date night with the entire bar staff.",
  "Pattern: big bills, bigger tips, biggest questions about your motives.",
  "You are subsidizing smiles across town.",
  "Multiple generous tabs. Crush energy or guilt energy — pick one.",
  "You tip like you want a statue and will settle for a nod.",
  "Your average gratuity is flirting with the industry as a whole.",
  "You leave twenty-five percent like it is a default personality setting.",
  "Generous history means either great service everywhere or you are easily impressed.",
  "You tip high often. Your bank app is taking notes.",
  "Repeat generosity is admirable or alarming depending on the rent.",
  "You tip like you are running for mayor of the bar.",
  "Another big tip logged. The pattern is not subtle.",
  "You are basically tipping your way through a sitcom arc.",
  "High average tip. Low average mystery.",
  "You keep paying premium prices for standard nights.",
  "Your tabs say you tip like you want to be remembered. You will be.",
  "You logged another tab downtown — shame ledger entry 1.",
  "You saved another tab around the corner — shame ledger entry 2.",
  "You documented another tab where everyone knows you — shame ledger entry 3.",
  "You celebrated another tab like it is your job — shame ledger entry 4.",
  "You rationalized another tab downtown — shame ledger entry 5.",
  "You logged another tab around the corner — shame ledger entry 6.",
  "You saved another tab where everyone knows you — shame ledger entry 7.",
  "You documented another tab like it is your job — shame ledger entry 8.",
  "You celebrated another tab downtown — shame ledger entry 9.",
  "You rationalized another tab around the corner — shame ledger entry 10.",
  "You logged another tab where everyone knows you — shame ledger entry 11.",
  "You saved another tab like it is your job — shame ledger entry 12.",
  "You documented another tab downtown — shame ledger entry 13.",
  "You celebrated another tab around the corner — shame ledger entry 14.",
  "You rationalized another tab where everyone knows you — shame ledger entry 15.",
  "You logged another tab like it is your job — shame ledger entry 16.",
  "You saved another tab downtown — shame ledger entry 17.",
  "You documented another tab around the corner — shame ledger entry 18.",
  "You celebrated another tab where everyone knows you — shame ledger entry 19.",
  "You rationalized another tab like it is your job — shame ledger entry 20.",
  "You logged another tab downtown — shame ledger entry 21.",
  "You saved another tab around the corner — shame ledger entry 22.",
  "You documented another tab where everyone knows you — shame ledger entry 23.",
  "You celebrated another tab like it is your job — shame ledger entry 24.",
  "You rationalized another tab downtown — shame ledger entry 25.",
  "You logged another tab around the corner — shame ledger entry 26.",
  "You saved another tab where everyone knows you — shame ledger entry 27.",
  "You documented another tab like it is your job — shame ledger entry 28.",
  "You celebrated another tab downtown — shame ledger entry 29.",
  "You rationalized another tab around the corner — shame ledger entry 30.",
  "You logged another tab where everyone knows you — shame ledger entry 31.",
  "You saved another tab like it is your job — shame ledger entry 32.",
  "You documented another tab downtown — shame ledger entry 33.",
  "You celebrated another tab around the corner — shame ledger entry 34.",
  "You rationalized another tab where everyone knows you — shame ledger entry 35.",
  "You logged another tab like it is your job — shame ledger entry 36.",
  "You saved another tab downtown — shame ledger entry 37.",
  "You documented another tab around the corner — shame ledger entry 38.",
  "You celebrated another tab where everyone knows you — shame ledger entry 39.",
  "You rationalized another tab like it is your job — shame ledger entry 40.",
  "You logged another tab downtown — shame ledger entry 41.",
  "You saved another tab around the corner — shame ledger entry 42.",
  "You documented another tab where everyone knows you — shame ledger entry 43.",
  "You celebrated another tab like it is your job — shame ledger entry 44.",
  "You rationalized another tab downtown — shame ledger entry 45.",
  "You logged another tab around the corner — shame ledger entry 46.",
  "You saved another tab where everyone knows you — shame ledger entry 47.",
  "You documented another tab like it is your job — shame ledger entry 48.",
  "You celebrated another tab downtown — shame ledger entry 49.",
  "You rationalized another tab around the corner — shame ledger entry 50.",
  "You logged another tab where everyone knows you — shame ledger entry 51.",
  "You saved another tab like it is your job — shame ledger entry 52.",
  "You documented another tab downtown — shame ledger entry 53.",
  "You celebrated another tab around the corner — shame ledger entry 54.",
  "You rationalized another tab where everyone knows you — shame ledger entry 55.",
  "You logged another tab like it is your job — shame ledger entry 56.",
  "You saved another tab downtown — shame ledger entry 57.",
  "You documented another tab around the corner — shame ledger entry 58.",
  "You celebrated another tab where everyone knows you — shame ledger entry 59.",
  "You rationalized another tab like it is your job — shame ledger entry 60.",
  "You logged another tab downtown — shame ledger entry 61.",
  "You saved another tab around the corner — shame ledger entry 62.",
  "You documented another tab where everyone knows you — shame ledger entry 63.",
  "You celebrated another tab like it is your job — shame ledger entry 64.",
  "You rationalized another tab downtown — shame ledger entry 65.",
  "You logged another tab around the corner — shame ledger entry 66.",
  "You saved another tab where everyone knows you — shame ledger entry 67.",
  "You documented another tab like it is your job — shame ledger entry 68.",
  "You celebrated another tab downtown — shame ledger entry 69.",
  "You rationalized another tab around the corner — shame ledger entry 70.",
  "You logged another tab where everyone knows you — shame ledger entry 71.",
  "You saved another tab like it is your job — shame ledger entry 72.",
  "You documented another tab downtown — shame ledger entry 73.",
  "You celebrated another tab around the corner — shame ledger entry 74.",
  "You rationalized another tab where everyone knows you — shame ledger entry 75.",
  "You logged another tab like it is your job — shame ledger entry 76.",
  "You saved another tab downtown — shame ledger entry 77.",
]

export const HABIT_BAR_HEAVY: readonly string[] = [
  "It is all bars, no vegetables. We see you.",
  "Restaurants exist. You keep choosing neon and regret.",
  "A liquid diet is still a diet. A stupid one.",
  "Your history is ninety percent bars. Salads exist. Allegedly.",
  "You log \"bar\" like it is a food group.",
  "Restaurant button untouched. Bar button worn out.",
  "You eat like a restaurant and drink like it is your job.",
  "Mostly bars. Mostly predictable. Mostly neon.",
  "Your tab types say stools over tables every time.",
  "You are not dining. You are parking at a tap handle.",
  "Bar-heavy history. Fiber-heavy regrets tomorrow.",
  "You treat restaurants like a myth and bars like home.",
  "Your calendar is bars with occasional accidental nutrition.",
  "Liquid dinners add up. So do the stories you forget.",
  "You chose bar again. Shocking absolutely no one.",
  "Your kind filter is basically a lifestyle confession.",
  "Tables are for people who chew. You log bars.",
  "Bar tab after bar tab. Where is the vegetable phase?",
  "You are loyal to pubs the way people are loyal to bad exes.",
  "Most entries say bar. Your liver has noticed.",
  "Restaurant category feeling neglected. Good.",
  "You drink out more than you dine out. Honesty in data form.",
  "Bar-heavy month. Hope you like amber lighting and questionable decisions.",
  "You logged another tab downtown — shame ledger entry 1.",
  "You saved another tab around the corner — shame ledger entry 2.",
  "You documented another tab where everyone knows you — shame ledger entry 3.",
  "You celebrated another tab like it is your job — shame ledger entry 4.",
  "You rationalized another tab downtown — shame ledger entry 5.",
  "You logged another tab around the corner — shame ledger entry 6.",
  "You saved another tab where everyone knows you — shame ledger entry 7.",
  "You documented another tab like it is your job — shame ledger entry 8.",
  "You celebrated another tab downtown — shame ledger entry 9.",
  "You rationalized another tab around the corner — shame ledger entry 10.",
  "You logged another tab where everyone knows you — shame ledger entry 11.",
  "You saved another tab like it is your job — shame ledger entry 12.",
  "You documented another tab downtown — shame ledger entry 13.",
  "You celebrated another tab around the corner — shame ledger entry 14.",
  "You rationalized another tab where everyone knows you — shame ledger entry 15.",
  "You logged another tab like it is your job — shame ledger entry 16.",
  "You saved another tab downtown — shame ledger entry 17.",
  "You documented another tab around the corner — shame ledger entry 18.",
  "You celebrated another tab where everyone knows you — shame ledger entry 19.",
  "You rationalized another tab like it is your job — shame ledger entry 20.",
  "You logged another tab downtown — shame ledger entry 21.",
  "You saved another tab around the corner — shame ledger entry 22.",
  "You documented another tab where everyone knows you — shame ledger entry 23.",
  "You celebrated another tab like it is your job — shame ledger entry 24.",
  "You rationalized another tab downtown — shame ledger entry 25.",
  "You logged another tab around the corner — shame ledger entry 26.",
  "You saved another tab where everyone knows you — shame ledger entry 27.",
  "You documented another tab like it is your job — shame ledger entry 28.",
  "You celebrated another tab downtown — shame ledger entry 29.",
  "You rationalized another tab around the corner — shame ledger entry 30.",
  "You logged another tab where everyone knows you — shame ledger entry 31.",
  "You saved another tab like it is your job — shame ledger entry 32.",
  "You documented another tab downtown — shame ledger entry 33.",
  "You celebrated another tab around the corner — shame ledger entry 34.",
  "You rationalized another tab where everyone knows you — shame ledger entry 35.",
  "You logged another tab like it is your job — shame ledger entry 36.",
  "You saved another tab downtown — shame ledger entry 37.",
  "You documented another tab around the corner — shame ledger entry 38.",
  "You celebrated another tab where everyone knows you — shame ledger entry 39.",
  "You rationalized another tab like it is your job — shame ledger entry 40.",
  "You logged another tab downtown — shame ledger entry 41.",
  "You saved another tab around the corner — shame ledger entry 42.",
  "You documented another tab where everyone knows you — shame ledger entry 43.",
  "You celebrated another tab like it is your job — shame ledger entry 44.",
  "You rationalized another tab downtown — shame ledger entry 45.",
  "You logged another tab around the corner — shame ledger entry 46.",
  "You saved another tab where everyone knows you — shame ledger entry 47.",
  "You documented another tab like it is your job — shame ledger entry 48.",
  "You celebrated another tab downtown — shame ledger entry 49.",
  "You rationalized another tab around the corner — shame ledger entry 50.",
  "You logged another tab where everyone knows you — shame ledger entry 51.",
  "You saved another tab like it is your job — shame ledger entry 52.",
  "You documented another tab downtown — shame ledger entry 53.",
  "You celebrated another tab around the corner — shame ledger entry 54.",
  "You rationalized another tab where everyone knows you — shame ledger entry 55.",
  "You logged another tab like it is your job — shame ledger entry 56.",
  "You saved another tab downtown — shame ledger entry 57.",
  "You documented another tab around the corner — shame ledger entry 58.",
  "You celebrated another tab where everyone knows you — shame ledger entry 59.",
  "You rationalized another tab like it is your job — shame ledger entry 60.",
  "You logged another tab downtown — shame ledger entry 61.",
  "You saved another tab around the corner — shame ledger entry 62.",
  "You documented another tab where everyone knows you — shame ledger entry 63.",
  "You celebrated another tab like it is your job — shame ledger entry 64.",
  "You rationalized another tab downtown — shame ledger entry 65.",
  "You logged another tab around the corner — shame ledger entry 66.",
  "You saved another tab where everyone knows you — shame ledger entry 67.",
  "You documented another tab like it is your job — shame ledger entry 68.",
  "You celebrated another tab downtown — shame ledger entry 69.",
  "You rationalized another tab around the corner — shame ledger entry 70.",
  "You logged another tab where everyone knows you — shame ledger entry 71.",
  "You saved another tab like it is your job — shame ledger entry 72.",
  "You documented another tab downtown — shame ledger entry 73.",
  "You celebrated another tab around the corner — shame ledger entry 74.",
  "You rationalized another tab where everyone knows you — shame ledger entry 75.",
  "You logged another tab like it is your job — shame ledger entry 76.",
  "You saved another tab downtown — shame ledger entry 77.",
]

export const HABIT_QUIET: readonly string[] = [
  "A quiet couple of weeks. Either growth or a dry January you will not admit.",
  "Not many tabs lately. The bartenders have moved on. Have you?",
  "Slow stretch. Log something or we will start roasting your grocery store deli.",
  "Nothing recent. Are you healing or hiding?",
  "Quiet history. Suspicious peace.",
  "No tabs this week. The app misses your chaos.",
  "You went dark. Respectfully concerned.",
  "Slow period. Either budgeting or boring.",
  "Not much logged lately. Did you move or just behave?",
  "The streak broke. We noticed.",
  "Few entries recently. Are you okay or just cooking?",
  "Your history went quiet. So did the roasts. Log something.",
  "No fresh tabs. The shame engine idles loudly.",
  "You have been home. Uncharacteristic or strategic?",
  "Light month on tabs. Heavy month on unknown activities.",
  "The bars miss you. Do you miss them?",
  "Quiet stretch. Do not make it a personality.",
  "Not going out is valid. Not logging is suspicious.",
  "Your recent silence is louder than your old tabs.",
  "Fewer nights out logged. Maybe growth. Maybe amnesia.",
  "The history thinned out. Fill it or face grocery store roasts.",
  "You paused going out. The app paused believing you.",
  "Slow weeks happen. So do relapses. We are watching.",
  "You logged another tab downtown — shame ledger entry 1.",
  "You saved another tab around the corner — shame ledger entry 2.",
  "You documented another tab where everyone knows you — shame ledger entry 3.",
  "You celebrated another tab like it is your job — shame ledger entry 4.",
  "You rationalized another tab downtown — shame ledger entry 5.",
  "You logged another tab around the corner — shame ledger entry 6.",
  "You saved another tab where everyone knows you — shame ledger entry 7.",
  "You documented another tab like it is your job — shame ledger entry 8.",
  "You celebrated another tab downtown — shame ledger entry 9.",
  "You rationalized another tab around the corner — shame ledger entry 10.",
  "You logged another tab where everyone knows you — shame ledger entry 11.",
  "You saved another tab like it is your job — shame ledger entry 12.",
  "You documented another tab downtown — shame ledger entry 13.",
  "You celebrated another tab around the corner — shame ledger entry 14.",
  "You rationalized another tab where everyone knows you — shame ledger entry 15.",
  "You logged another tab like it is your job — shame ledger entry 16.",
  "You saved another tab downtown — shame ledger entry 17.",
  "You documented another tab around the corner — shame ledger entry 18.",
  "You celebrated another tab where everyone knows you — shame ledger entry 19.",
  "You rationalized another tab like it is your job — shame ledger entry 20.",
  "You logged another tab downtown — shame ledger entry 21.",
  "You saved another tab around the corner — shame ledger entry 22.",
  "You documented another tab where everyone knows you — shame ledger entry 23.",
  "You celebrated another tab like it is your job — shame ledger entry 24.",
  "You rationalized another tab downtown — shame ledger entry 25.",
  "You logged another tab around the corner — shame ledger entry 26.",
  "You saved another tab where everyone knows you — shame ledger entry 27.",
  "You documented another tab like it is your job — shame ledger entry 28.",
  "You celebrated another tab downtown — shame ledger entry 29.",
  "You rationalized another tab around the corner — shame ledger entry 30.",
  "You logged another tab where everyone knows you — shame ledger entry 31.",
  "You saved another tab like it is your job — shame ledger entry 32.",
  "You documented another tab downtown — shame ledger entry 33.",
  "You celebrated another tab around the corner — shame ledger entry 34.",
  "You rationalized another tab where everyone knows you — shame ledger entry 35.",
  "You logged another tab like it is your job — shame ledger entry 36.",
  "You saved another tab downtown — shame ledger entry 37.",
  "You documented another tab around the corner — shame ledger entry 38.",
  "You celebrated another tab where everyone knows you — shame ledger entry 39.",
  "You rationalized another tab like it is your job — shame ledger entry 40.",
  "You logged another tab downtown — shame ledger entry 41.",
  "You saved another tab around the corner — shame ledger entry 42.",
  "You documented another tab where everyone knows you — shame ledger entry 43.",
  "You celebrated another tab like it is your job — shame ledger entry 44.",
  "You rationalized another tab downtown — shame ledger entry 45.",
  "You logged another tab around the corner — shame ledger entry 46.",
  "You saved another tab where everyone knows you — shame ledger entry 47.",
  "You documented another tab like it is your job — shame ledger entry 48.",
  "You celebrated another tab downtown — shame ledger entry 49.",
  "You rationalized another tab around the corner — shame ledger entry 50.",
  "You logged another tab where everyone knows you — shame ledger entry 51.",
  "You saved another tab like it is your job — shame ledger entry 52.",
  "You documented another tab downtown — shame ledger entry 53.",
  "You celebrated another tab around the corner — shame ledger entry 54.",
  "You rationalized another tab where everyone knows you — shame ledger entry 55.",
  "You logged another tab like it is your job — shame ledger entry 56.",
  "You saved another tab downtown — shame ledger entry 57.",
  "You documented another tab around the corner — shame ledger entry 58.",
  "You celebrated another tab where everyone knows you — shame ledger entry 59.",
  "You rationalized another tab like it is your job — shame ledger entry 60.",
  "You logged another tab downtown — shame ledger entry 61.",
  "You saved another tab around the corner — shame ledger entry 62.",
  "You documented another tab where everyone knows you — shame ledger entry 63.",
  "You celebrated another tab like it is your job — shame ledger entry 64.",
  "You rationalized another tab downtown — shame ledger entry 65.",
  "You logged another tab around the corner — shame ledger entry 66.",
  "You saved another tab where everyone knows you — shame ledger entry 67.",
  "You documented another tab like it is your job — shame ledger entry 68.",
  "You celebrated another tab downtown — shame ledger entry 69.",
  "You rationalized another tab around the corner — shame ledger entry 70.",
  "You logged another tab where everyone knows you — shame ledger entry 71.",
  "You saved another tab like it is your job — shame ledger entry 72.",
  "You documented another tab downtown — shame ledger entry 73.",
  "You celebrated another tab around the corner — shame ledger entry 74.",
  "You rationalized another tab where everyone knows you — shame ledger entry 75.",
  "You logged another tab like it is your job — shame ledger entry 76.",
  "You saved another tab downtown — shame ledger entry 77.",
]
